import { NetworkStatus } from '@features/eInvoicing/types'

import { getIsAppTestingEnvironment } from '../../../../utils/getIsAppTestingEnvironment'

export const getIsPdpPeppolStatusApplied = (eInvoiceIntegrationPdpNetworkStatus: NetworkStatus | undefined) => {
  const isTestingEnvironment = getIsAppTestingEnvironment()
  if (isTestingEnvironment) {
    return ['appliedInPeppolSmp', 'noChangeRequired'].includes(eInvoiceIntegrationPdpNetworkStatus?.peppolStatus ?? '')
  }

  return eInvoiceIntegrationPdpNetworkStatus?.peppolStatus === 'appliedInPeppolSmp'
}
